<template>
  <div>
    <a
      class="dropdown-toggle nav-underline text-black"
      data-bs-toggle="dropdown"
      href="#"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{ $store.state.hitsPerPage }} {{ gettext('producten per pagina') }}
      <span class="caret"></span>
    </a>
    <ul class="dropdown-menu">
      <li class="dropdown-item p-0" v-for="option in options" :key="option">
        <button
          :class="{
            btn: true,
            'btn-link': true,
            active: option === $store.state.hitsPerPage,
          }"
          @click.prevent="setHitsPerPage(option)"
        >
          {{ option }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [48, 60, 120, 250],
    };
  },
  methods: {
    setHitsPerPage(n) {
      this.$store.commit('setHitsPerPage', n);
    },
  },
};
</script>
